import { actionTypes } from 'redux-router5';
import { Record } from 'immutable';

var State = Record({
    route: null,
    previousRoute: null,
    transitionRoute: null,
    transitionError: null
});
function router5Reducer(state, action) {
    if (state === void 0) { state = new State(); }
    switch (action.type) {
        case actionTypes.TRANSITION_START:
            return state
                .set('transitionRoute', action.payload.route)
                .set('transitionError', null);
        case actionTypes.TRANSITION_SUCCESS:
            return state
                .set('transitionRoute', null)
                .set('transitionError', null)
                .set('previousRoute', action.payload.previousRoute)
                .set('route', action.payload.route);
        case actionTypes.TRANSITION_ERROR:
            return state
                .set('transitionRoute', action.payload.route)
                .set('transitionError', action.payload.transitionError);
        case actionTypes.CLEAR_ERRORS:
            return state
                .set('transitionRoute', null)
                .set('transitionError', null);
        default:
            return state;
    }
}

export { router5Reducer };
